import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

const ConfirmModal = ({ 
  open, 
  onOpenChange, 
  title = 'Əminsiniz?', 
  description = 'Bu əməliyyat geri qaytarıla bilməz.',
  confirmText = 'Sil',
  cancelText = 'Ləğv et',
  onConfirm,
  isLoading = false
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white rounded-2xl border-0 shadow-warm-lg" data-testid="confirm-modal">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-2xl text-brand-brown" data-testid="confirm-modal-title">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-brand-muted" data-testid="confirm-modal-description">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            className="rounded-full border-2 border-brand-secondary text-brand-brown hover:bg-brand-secondary/30 px-6"
            data-testid="confirm-modal-cancel"
          >
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            disabled={isLoading}
            className="rounded-full bg-red-500 text-white hover:bg-red-600 px-6"
            data-testid="confirm-modal-confirm"
          >
            {isLoading ? 'Silinir...' : confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmModal;
